import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const InfoPopup = ({ closePopup }) => {
    const [distributorInfo, setDistributorInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [apiData, setApiData] = useState(false);

    const userdata = useMemo(() => {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch {
            return null;
        }
    }, []);

    const getRepsDetailWithOutCND = useCallback(() => {
        if (!userdata) return;

        const roleName = userdata.paramsname;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({
                RoleName: roleName,
                RoleType: userdata.wholesaler,
                wholesaler_Id: userdata.wholesaler_Id,
                distributor_UserId: userdata.distributor_UserId
            })
        };

        setLoading(true);
        fetch(`/api/ds/repsNewInfo`, requestOptions)
            .then(response => response.json())
            .then(data => {
                setDistributorInfo(data || []);
                setLoading(false);
                setApiData(true);
            })
            .catch(error => {
                setLoading(false);
                setApiData(true);
            });
    }, [userdata]);

    useEffect(() => {
        getRepsDetailWithOutCND();
    }, [getRepsDetailWithOutCND]);

    return (
        <Dialog open={true} onOpenChange={closePopup}>
            <DialogContent className="max-w-2xl">
                <DialogHeader>
                    <DialogTitle>My Info</DialogTitle>
                </DialogHeader>

                {loading ? (
                    <div className="flex justify-center items-center py-12">
                        <Loader2 className="h-8 w-8 animate-spin text-primary" />
                    </div>)
                : (
                    <div className="space-y-6">
                        {distributorInfo && distributorInfo.length > 0 ? (
                            <>
                                <Card>
                                    <CardContent className="pt-6">
                                        <div className="grid grid-cols-2 gap-6">
                                            <div>
                                                <p className="text-sm text-muted-foreground mb-2">Total Active Reps</p>
                                                <p className="text-2xl font-semibold">{distributorInfo[0].activeCount} Reps</p>
                                            </div>
                                            <div>
                                                <p className="text-sm text-muted-foreground mb-2">Total Inactive Reps</p>
                                                <p className="text-2xl font-semibold">{distributorInfo[0].inactiveCount} Reps</p>
                                            </div>
                                        </div>
                                    </CardContent>
                                </Card>

                                <div>
                                    <h3 className="text-sm font-medium mb-3">
                                        Assigned Group Numbers (My Commission Per Claim)
                                    </h3>
                                    <div className="flex flex-wrap gap-2">
                                        {distributorInfo.map((gpitem, index) => (
                                            <Badge key={index} variant="secondary" className="text-sm">
                                                {gpitem.groupNumber}
                                            </Badge>
                                        ))}
                                    </div>
                                </div>

                                <div className="flex justify-end">
                                    <Button onClick={closePopup}>Close</Button>
                                </div>
                            </>
                        ) : (
                            apiData && (
                                <div className="text-center py-12 text-muted-foreground">
                                    Data not available
                                </div>
                            )
                        )}
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default InfoPopup;